/*
Item: Form to xxx
Name:
Format: Frontend component, partial screen
*/
import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dialog } from 'primereact/dialog';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import MessageService from '../service/MessageService';
import TreeTableWrapper from '../components/TreeTableWrapper';
import JsonHelper, {
  KeyFigureNames,
  KeyStatusNames,
  KeyFigureStatistics,
  KeyFigureKey,
  KeyChildren,
  KeyLinksArray,
} from '../utils/statisticsUtils';
import { MultiLanguage } from '../utils/MultiLanguage';
import KeyFigureAdminDialog from '../components/dialogue/KeyFigureAdminDialog';

const DialogType = Object.freeze({
  none: 0,
  rename: 1,
  delete: 2,
  footnote: 3,
});

function convertToLocal(convertTime) {
  let d = '';
  if (convertTime) {
    // correct time to local
    const year = convertTime.substring(6, 10);
    const month = convertTime.substring(3, 5);
    const day = convertTime.substring(0, 2);
    const time = convertTime.substring(11, 19);
    const dateString = `${month} ${day} ${year} ${time} GMT`;
    const curr = Date.parse(dateString);
    d = new Date(curr);
  }
  return d;
}

function baseTemplate(rowData) {
  let retText;
  if (rowData.data.basisCube) {
    retText = (<i className="pi pi-md-check" />);
  } else {
    retText = '';
  }
  return (
    <span>
      {retText}
    </span>
  );
}

export default class KeyFigureAdmin extends Component {
  constructor() {
    super();
    this.state = {
      // state for wait spinner dialog
      visibleWait: false,
      allNodes: {},
      currentDialogType: DialogType.none,
      currentNode: undefined,
      // footnote: '',
    };
    this.actionTemplate = this.actionTemplate.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.onHide = this.onHide.bind(this);
    this.confirmDialog = this.confirmDialog.bind(this);
    this.setNewNodeDataName = this.setNewNodeDataName.bind(this);
    this.setNewFootnote = this.setNewFootnote.bind(this);
    this.saveBackEnd = this.saveBackEnd.bind(this);
    this.multiLanguage = new MultiLanguage();
    this.messageService = new MessageService();
    this.myTreeTable = React.createRef();
  }

  componentDidMount = async () => {
    this.setState({ visibleWait: true });
    try {
      const right = 'ALL';
      const allNodes = await this.getDirectory(right);
      this.setState({ allNodes });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('error in componentDidMount', err);
    } finally {
      this.setState({ visibleWait: false });
    }
  }

  onHide() {
    this.setState({
      currentDialogType: DialogType.none,
      currentNode: undefined,
    });
  }

  setNewNodeDataName(name) {
    this.setState({ newNodeDataName: name });
  }

  setNewFootnote(name) {
    this.setState({ newFootnote: name });
  }

  async getDirectory(right) {
    const children = KeyChildren;
    let entriesTable0 = [];
    let entriesTable1 = [];
    let entriesCube0 = [];
    let entriesCube1 = [];
    let type = 'cube';
    let objectTyp = 'CUBE';
    let objectNumber = '9';
    const elementsData = await this.messageService.postVariableDirectory('directory', type, right, objectNumber, objectTyp, undefined, undefined, KeyLinksArray[213811]);
    if (elementsData.data) {
      entriesCube0 = elementsData.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
    }
    const elementsData1 = await this.messageService.postVariableDirectory('directory', type, right, objectNumber, objectTyp, undefined, undefined, KeyLinksArray[213812]);
    if (elementsData1.data) {
      entriesCube1 = elementsData1.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
    }
    const entriesCube = entriesCube0.concat(entriesCube1);
    type = 'structure';
    objectTyp = 'STRUCTURE';
    objectNumber = '108';
    const elementsDataTable0 = await this.messageService.postVariableDirectory('directory', type, right, objectNumber, objectTyp, undefined, undefined, KeyLinksArray[213811]);
    if (elementsDataTable0.data) {
      entriesTable0 = JsonHelper.deepCopy(elementsDataTable0.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys);
      for (let n0 = 0; n0 < entriesTable0.length; n0 += 1) {
        entriesTable0[n0].statistics = '213811';
      }
    }
    const elementsDataTable1 = await this.messageService.postVariableDirectory('directory', type, right, objectNumber, objectTyp, undefined, undefined, KeyLinksArray[213812]);
    if (elementsDataTable1.data) {
      entriesTable1 = JsonHelper.deepCopy(elementsDataTable1.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys);
      for (let n1 = 0; n1 < entriesTable1.length; n1 += 1) {
        entriesTable1[n1].statistics = '213812';
      }
    }
    const entriesTable = entriesTable0.concat(entriesTable1);
    const arrEntries = [entriesCube, entriesTable];
    for (let level = 0; level < arrEntries.length; level += 1) {
      const entries = arrEntries[level];
      const count = { // counts monetary / non-monetary entries
        213811: 0,
        213812: 0,
      };
      for (let ii = 0; ii < entries.length; ii += 1) {
        if (entries[ii]) {
          let timeName = ''; // 2645
          if (entries[ii].timeSlices) {
            if (entries[ii].timeSlices[0]) {
              timeName = entries[ii].timeSlices[0].name;
            }
          }
          const dStart = convertToLocal(entries[ii].modifiedDatabaseTime);
          const modifiedDate = dStart.toLocaleDateString('de-DE', { month: '2-digit', day: '2-digit', year: 'numeric' });
          children[
            KeyFigureKey[entries[ii].statistics]
          ].children[level].children[count[entries[ii].statistics]
          ] = {
            key: `${KeyFigureKey[entries[ii].statistics]}-${level}-${count[entries[ii].statistics]}`,
            type: entries[ii].label ? 'cube' : 'structure',
            data: {
              statistics: entries[ii].statistics,
              keyStatistics: KeyFigureStatistics[entries[ii].statistics],
              statisticID: entries[ii].statisticID,
              id: entries[ii].id,
              basisCube: entries[ii].basisCube,
              status: KeyStatusNames[entries[ii].status],
              name: entries[ii].name,
              explanation: entries[ii].label ? this.multiLanguage.returnLanguage(entries[ii].label, 'de') : '',
              time: timeName,
              modifiedDate,
              selectable: true,
            },
          };
          count[entries[ii].statistics] += 1;
        }
      }
    }
    return children;
  }

  // eslint-disable-next-line react/sort-comp
  actionTemplate(node) {
    return (
      <div>
        {node.data.selectable ? (
          <span>
            { node.data.explanation === '' ? (
              <Button
                title="Fußnote bearbeiten"
                type="button"
                icon="pi-md-announcement"
                className="p-button-info"
                onClick={() => this.openDialog(node, DialogType.footnote)}
              />
            ) : undefined}
            <Button
              title="Umbenennen"
              type="button"
              icon="pi-md-edit"
              className="p-button-info"
              onClick={() => this.openDialog(node, DialogType.rename)}
            />
            <Button
              type="button"
              icon="pi-md-delete"
              title="Löschen"
              className="p-button-danger"
              onClick={() => this.openDialog(node, DialogType.delete)}
            />
          </span>
        ) : undefined}
      </div>
    );
  }


  async openDialog(node, type) {
    // const { footnote } = this.state;
    const newState = { currentDialogType: type, currentNode: node };
    if (type === DialogType.rename) {
      newState.newNodeDataName = node.data.name;
    }
    if (type === DialogType.footnote) {
      try {
        this.setState({ visibleWait: true });
        // für Eigenschaften Tabelle
        let { footnote } = this.state;
        const { id } = node.data;
        const objectNumber = '108';
        const objectType = 'structure';
        // Eingenschaften abrufen
        const footnoteData = await this.messageService.postRecordStructureProperties(
          id, objectNumber, objectType, false,
        );
        if (footnoteData[0]) {
          const message = footnoteData[0].replace('java.lang.Exception:', '');
          this.growl.show({ severity: footnoteData[1], summary: 'Hinweis', detail: message });
        } else {
          const { entrys } = footnoteData.contents['genesis.container.content.GenesisTMContent'].transfermodel;
          if (entrys[0].footnote) {
            footnote = this.multiLanguage.returnLanguage(entrys[0].footnote, 'de');
          }
        }
      } catch (err) {
        console.log('error in viewProperties:', err);
      } finally {
        this.setState({ visibleWait: false });
      }
      newState.newFootnote = footnote;
    }
    this.setState(newState);
  }

  async deleteNode(currentNodeEnvironment) {
    let success = true;
    const { nodesArray, newNodeDataName } = currentNodeEnvironment;
    const node = nodesArray[currentNodeEnvironment.position];
    const { objectNumber, type } = node;
    const { id } = node.data;
    if (newNodeDataName) node.data.name = newNodeDataName; // funktioniert nicht hinter dem await!
    const elementsData = await this.messageService.postRecordStructureProperties(
      id, objectNumber, type, false,
    );
    if (elementsData[0]) {
      success = false;
      this.growl.show({
        severity: elementsData[1],
        summary: 'Hinweis',
        detail: elementsData[0],
        life: 15000,
      });
    } else {
      const insertMessage = JsonHelper.deepCopy(elementsData);
      // remove selection from parameter-hashmap in message to prevent
      // searching for id instead of FachId which would work here
      insertMessage.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.selektion = [];
      const link = 'delete';
      const ret = await this.messageService.postRecordStructureProperties(
        id, objectNumber, type, false, undefined, insertMessage, link,
      );
      if (ret[0]) {
        success = false;
        const message = ret[0].replace('java.lang.Exception:', '');
        this.growl.show({
          severity: ret[1],
          summary: 'Hinweis',
          detail: message,
          life: 15000,
        });
      }
    }
    return success;
  }

  async changeFootnote(node) {
    let success = true;
    const { id } = node.data;
    const { objectNumber, type } = node;
    const { newFootnote } = this.state;
    const link = 'update';
    const elementsData = await this.messageService.postRecordStructureProperties(
      id, objectNumber, type, false,
    );
    const insertMessage = JsonHelper.deepCopy(elementsData);
    const template = {
      '@type': 'MehrsprachigerText',
      langText: [
        {
          '@type': 'Text',
          sprachKennzeichen: 'de',
          text: 'test1',
          approved: false,
          format: 'text_plain',
        },
      ],
    };
    const check = insertMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0];
    if (!check.footnote) {
      insertMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].footnote = template;
    }
    insertMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].footnote.langText[0].text = newFootnote;
    const ret = await this.messageService.postRecordStructureProperties(
      id, objectNumber, type, false, undefined, insertMessage, link,
    );
    if (ret[0]) {
      const message = ret[0].replace('java.lang.Exception:', '');
      this.growl.show({ severity: ret[1], summary: 'Hinweis', detail: message });
      success = false;
    }
    return success;
  }

  async renameNode(node) {
    console.log('RENAME#1');
    let success = true;
    const { id } = node.data;
    const { objectNumber, type } = node;
    const { newNodeDataName } = this.state;
    const elementsData = await this.messageService.postRecordStructureProperties(
      id, objectNumber, type, false,
    );
    if (elementsData[0]) {
      this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
      success = false;
    } else {
      const insertMessage = JsonHelper.deepCopy(elementsData);
      insertMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].name = newNodeDataName;
      const link = 'update';
      const ret = await this.messageService.postRecordStructureProperties(
        id, objectNumber, type, false, undefined, insertMessage, link,
      );
      if (ret[0]) {
        const message = ret[0].replace('java.lang.Exception:', '');
        this.growl.show(
          {
            life: 4000, severity: ret[1], summary: 'Hinweis', detail: message,
          },
        );
        success = false;
      }
    }
    return success;
  }

  async saveBackEnd(node, argNewNodeDataName, statisticName, topicType,
    actionLink, argNodesArray, argCurrentNodeEnvironment, oldName) {
    const currentNodeEnvironment = argCurrentNodeEnvironment;
    const { newNodeDataName, newFootnote } = this.state;
    let { allNodes } = this.state;
    let success = false;
    this.setState({ visibleWait: true });
    try {
      if (actionLink === 'footnote') {
        success = await this.changeFootnote(node, newFootnote);
      } else if (actionLink === 'delete') {
        success = await this.deleteNode(currentNodeEnvironment);
      } else {
        success = await this.renameNode(node, newNodeDataName);
        if (success) {
          // umbenennen im FE
          currentNodeEnvironment.nodesArray[
            currentNodeEnvironment.position].data.name = newNodeDataName;
          const { nodesArray } = currentNodeEnvironment;
          // allNodes = [...allNodes];
          // allNodes = JsonHelper.deepCopy(allNodes);
          const category = nodesArray[0].key.split('-')[0];
          const subCategory = nodesArray[0].key.split('-')[1];
          allNodes[category].children[subCategory].children = nodesArray;
          this.setState({ allNodes });
        } else {
          currentNodeEnvironment.nodesArray[
            currentNodeEnvironment.position].data.name = oldName;
        }
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Error in saveBackEnd', err);
    } finally {
      this.setState({ visibleWait: false });
    }
    return success;
  }

  async confirmDialog() {
    const {
      currentNode, allNodes, currentDialogType,
    } = this.state;
    const { key } = currentNode;
    const currentNodeEnvironment = this.myTreeTable.current.findNodeEnvironment(allNodes, key);
    // const { nodesArray } = currentNodeEnvironment;
    // let success;
    switch (currentDialogType) {
      case DialogType.rename:
        this.myTreeTable.current.renameNode(currentNodeEnvironment);
        break;
      case DialogType.delete:
        this.myTreeTable.current.deleteNode(currentNodeEnvironment, true);
        break;
      case DialogType.footnote:
        this.myTreeTable.current.footnoteNode(currentNodeEnvironment, true);
        break;
      default:
      // nothing yet
    }
    this.setState({ allNodes }, () => this.onHide());
  }

  // eslint-disable-next-line class-methods-use-this
  typeTemplate(node) {
    return (
      node.data.typ === 'DEFAULT' ? (
        <span>
          {node.data.name}
          <i title="Standardtabelle" className="pi pi-md-local-offer" />
        </span>
      ) : node.data.name
    );
  }

  render() {
    const key = window.location.href.split('&')[1];
    const {
      visibleWait, allNodes, currentNode, currentDialogType, newNodeDataName, newFootnote,
    } = this.state;
    return (
      <div className="p-col-12 p-lg-12">
        {/* This Dialogue is for waiting */}
        <Dialog header="Lade Daten..." closable={false} closeOnEscape={false} visible={visibleWait} modal onHide={() => this.setState({ visibleWait: false })}>
          <div style={{ textAlign: 'center' }}><ProgressSpinner /></div>
        </Dialog>
        {/* Pop-up hints */}
        <Growl ref={(el) => { this.growl = el; }} />
        {/* Layout */}
        <h2>{KeyFigureNames[key]}</h2>
        <div className="p-col-2 p-md-12">
          {/* content listing */}
          <TreeTableWrapper
            ref={this.myTreeTable}
            allNodes={allNodes}
            saveBackEnd={this.saveBackEnd}
            newNodeDataName={newNodeDataName}
            newFootnote={newFootnote}
          >
            <Column
              style={{ width: '16em' }}
              body={this.typeTemplate}
              header="Bezeichnung"
              expander
            />
            <Column
              field="explanation"
              header="Beschriftung"
            />
            <Column
              field="basisCube"
              header="Basis"
              body={baseTemplate}
              style={{ width: '4em' }}
            />
            <Column
              style={{ width: '8em' }}
              field="status"
              header="Status"
            />
            <Column
              style={{ width: '4em' }}
              field="time"
              header="Zeit"
            />
            <Column
              style={{ width: '10em' }}
              field="modifiedDate"
              header="Letzte Änderung"
            />
            <Column
              header="Aktionen"
              body={this.actionTemplate}
              style={{ width: '8rem', textAlign: 'right' }}
            />
          </TreeTableWrapper>
          {/* dialog for action buttons */}
          <KeyFigureAdminDialog
            onHide={this.onHide}
            currentNode={currentNode}
            confirmDialog={this.confirmDialog}
            currentDialogType={currentDialogType}
            setNewNodeDataName={this.setNewNodeDataName}
            setNewFootnote={this.setNewFootnote}
            newNodeDataName={newNodeDataName}
            newFootnote={newFootnote}
            // nodes={nodes}
            allNodes={allNodes}
          />
        </div>
      </div>
    );
  }
}
